import { BarChart as MantineBarChart } from '@mantine/charts'
import { useMediaQuery } from '@mantine/hooks'
import { FULL_MONTH } from '../months'

type BarChartProps = {
  data: Array<{ label: string; value: number | null | undefined }>
  getColor: (value: number) => string
  formatValue: (value: number) => string
  valueLabel: string
}

export default function BarChart(props: BarChartProps) {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const data = props.data.map(({ label, value }) => ({
    [props.valueLabel]: value,
    label,
  }))
  return (
    <MantineBarChart
      styles={{
        tooltip: {
          backgroundColor: 'light-dark(white, var(--mantine-color-gray-9)',
        },
      }}
      h="100%"
      w="100%"
      data={data}
      getBarColor={props.getColor}
      dataKey="label"
      series={[{ name: props.valueLabel, color: 'gray' }]}
      yAxisProps={{}}
      valueFormatter={props.formatValue}
      barChartProps={{}}
      barProps={{ barSize: 16 }}
      xAxisProps={{
        tickFormatter: (label: string) => (isDesktop ? label : label[0]),
      }}
      tooltipProps={{
        labelFormatter: (label: string) => FULL_MONTH[label] || label,
      }}
    />
  )
}
